export function mapKeys(object, callback) {
    return Object
        .keys(object)
        .reduce(function(accumulator, key) {
            accumulator[callback(key)] = object[key]

            return accumulator
        }, {})
}
